(function ($) {
  $(document).ready(function () {
    $(".menu-btn>a").click(function () {
      $("body").addClass("no-scroll");
      $(".mobile-menu").addClass("active");
    });
    $(".menu-close>a").click(function () {
      $("body").removeClass("no-scroll");
      $(".mobile-menu").removeClass("active");
    });

    $(".mobile-menu-link li a").on("click", function () {
      var target = $(this).attr("data-rel");
      $(".mobile-menu-link li a").removeClass("active");
      $(this).addClass("active");
      $("#" + target)
        .fadeIn("slow")
        .siblings(".megamenu")
        .hide();
      return false;
    });

    //.faq-list li a
    $(".faq-list li a").click(function (e) {
      e.preventDefault();

      var href = $(this).attr("href");
      var headerH = $(".header_wrap").innerHeight();
      var headerTH = headerH + 15;
      var scrollTo = $(href).offset().top - headerTH;

      $("html, body").animate(
        {
          scrollTop: scrollTo,
        },
        400
      );
    });

    $(".cart-icon").click(function () {
      // $('body').addClass('no-scroll');
      $(".side-cart").addClass("active", 250);
    });
    $(".hhja").click(function () {
      //   $('body').addClass('no-scroll');
      $(".side-cart").addClass("active", 250);
    });
    $(".close-cart").click(function () {
      $("body").removeClass("no-scroll");
      $(".side-cart").removeClass("active", 250);
    });

    $(".layer14").on("click", function (e) {
      e.preventDefault(); // prevent hard jump, the default behavior
      var target = $(this).attr("href"); // Set the target as variable
      console.log(target);

      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $(target).offset().top - 100,
          },
          600,
          function () {
            //location.hash = target; //attach the hash (#jumptarget) to the pageurl
            console.log($(target).offset().top);
          }
        );

      return false;
    });
    $(".down-btn").on("click", function (e) {
      e.preventDefault(); // prevent hard jump, the default behavior
      var target = $(this).attr("href"); // Set the target as variable
      console.log(target);

      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $(target).offset().top - 50,
          },
          600,
          function () {
            //location.hash = target; //attach the hash (#jumptarget) to the pageurl
            console.log($(target).offset().top);
          }
        );

      return false;
    });
    $(".down-btn2").on("click", function (e) {
      e.preventDefault(); // prevent hard jump, the default behavior
      var target = $(this).attr("href"); // Set the target as variable
      console.log(target);

      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $(target).offset().top - 340,
          },
          600,
          function () {
            //location.hash = target; //attach the hash (#jumptarget) to the pageurl
            console.log($(target).offset().top);
          }
        );

      return false;
    });

    $(".omni-collection-banner-footer .down-btn2, .omni-sample-collection-banner-footer .down-btn2 ").on("click", function (e) {
      e.preventDefault(); // prevent hard jump, the default behavior
      var target = $(this).attr("href"); // Set the target as variable
      console.log(target);

      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $(target).offset().top - 120,
          },
          600,
          function () {
            //location.hash = target; //attach the hash (#jumptarget) to the pageurl
            console.log($(target).offset().top);
          }
        );

      return false;
    });

    $(".hero-slider").slick({
      dots: true,
      infinite: true,
      arrows: false,
      //fade:true,
      slidesToShow: 1,
      asNavFor: ".ab-industry-nav",
      slidesToScroll: 1,
    });

    $(".ab-industry-nav").slick({
      dots: false,
      infinite: true,
      arrows: false,
      //fade:true,
      asNavFor: ".hero-slider",
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    $("#slider").layerSlider({
      sliderVersion: "6.0.0",
      type: "fullsize",
      responsiveUnder: 1,
      layersContainer: 1600,
      maxRatio: 1,
      parallaxScrollReverse: true,
      hideUnder: 0,
      hideOver: 100000,
      skin: "v6",
      allowRestartOnResize: true,
      thumbnailNavigation: "disabled",
      skinsPath: "../../layerslider/skins/",
      height: 1048,
    });

    $("#slider2").layerSlider({
      sliderVersion: "6.0.0",
      type: "fullsize",
      responsiveUnder: 1,
      layersContainer: 375,
      maxRatio: 1,
      parallaxScrollReverse: true,
      hideUnder: 0,
      hideOver: 100000,
      skin: "v6",
      allowRestartOnResize: true,
      thumbnailNavigation: "disabled",
      skinsPath: "../../layerslider/skins/",
      height: 741,
    });

    $(".a-what-new-slide").slick({
      dots: true,
      infinite: false,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      prevArrow: $(".prev"),
      nextArrow: $(".next"),
      centerPadding: "370px",
      accesibility: false,
      draggable: false,
      swipe: false,
      touchMove: false,
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "221px",
            accesibility: false,
            draggable: false,
            swipe: false,
            touchMove: false,
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "221px",
            accesibility: false,
            draggable: false,
            swipe: false,
            touchMove: false,
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "140px",
            accesibility: false,
            draggable: false,
            swipe: false,
            touchMove: false,
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "20px",
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: "20px",
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: "0",
            slidesToScroll: 1,
            accesibility: true,
            draggable: true,
            swipe: true,
            touchMove: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: "120px",
            slidesToScroll: 1,
            accesibility: true,
            draggable: true,
            swipe: true,
            touchMove: true,
          },
        },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     centerMode: true,
        //     centerPadding: '30px',
        //     slidesToScroll: 1
        //   }
        // },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: "120px",
            slidesToScroll: 1,
            accesibility: true,
            draggable: true,
            swipe: true,
            touchMove: true,
          },
        },
      ],
    });

    $(".custom-slide").slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: $(".prevb"),
      nextArrow: $(".nextb"),
      centerPadding: "222px",
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "140px",
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "20px",
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            centerPadding: "20px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            arrows: false,
            centerPadding: "40px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            initialSlide: 1,
            centerMode: false,
            arrows: false,
            centerPadding: "0px",
            slidesToScroll: 1,
          },
        },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     centerMode: true,
        //     centerPadding: '30px',
        //     slidesToScroll: 1
        //   }
        // },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            initialSlide: 0,
            centerMode: false,
            arrows: false,
            centerPadding: "60px",
            slidesToScroll: 1,
          },
        },
      ],
    });

    $(".quantum-collection-row .custom-slide2").slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: $(".prevb"),
      nextArrow: $(".nextb"),
      centerPadding: '222px',
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: '221px',
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "140px",
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "20px",
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            centerPadding: "20px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            initialSlide: 1,
            centerMode: false,
            arrows: true,
            centerPadding: "40px",
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            arrows: true,
            centerPadding: "120px",
            slidesToScroll: 2,
          },
        },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     centerMode: false,
        //     centerPadding: '30px',
        //     slidesToScroll: 3
        //   }
        // },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            infinite: true,
            centerMode: false,
            arrows: true,
            centerPadding: "20px",
            slidesToScroll: 2,
            initialSlide: 0,
          },
        },
      ],
    });

    $(".quantum-collection-row .sample-kit-slider").slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: $(".prevb"),
      nextArrow: $(".nextb"),
      centerPadding: '222px',
      responsive: [
        {
          breakpoint: 2500,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: '221px',
          },
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: '221px',
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "140px",
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: false,
            centerPadding: "20px",
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            initialSlide: 1,
            centerMode: false,
            centerPadding: "20px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            arrows: true,
            centerPadding: "40px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            initialSlide: 1,
            centerMode: false,
            arrows: true,
            centerPadding: "120px",
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            infinite: true,
            centerMode: false,
            arrows: true,
            centerPadding: "20px",
            slidesToScroll: 1,
            initialSlide: 0,
          },
        },
      ],
    });


    $(".quantum-collection-row .custom-slide3").slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 300,
      centerMode: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: $(".prevb"),
      nextArrow: $(".nextb"),
      centerPadding: '222px',
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            //  slidesToShow: 3,
            //  slidesToScroll: 3,
            //  centerMode: true,
            // centerPadding: '221px',
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "140px",
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "20px",
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            centerPadding: "20px",
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            arrows: true,
            centerPadding: "40px",
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            arrows: false,
            centerPadding: "120px",
            slidesToScroll: 1,
          },
        },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     centerMode: true,
        //     centerPadding: '30px',
        //     slidesToScroll: 1
        //   }
        // },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            arrows: true,
            centerPadding: "125px",
            slidesToScroll: 1,
          },
        },
      ],
    });


    //       $('.custom-arrow .prevb').on('click', function() {
    //     $('.custom-slide3.slick-slider').find('.slick-prev').trigger('click');
    // });


    // $('.custom-arrow .nextb').on('click', function() {
    //     $('.custom-slide3.slick-slider').find('.slick-next').trigger('click');
    // });


    // if ($(window).width() > 768) {
    //   $(".other-pro-head .nextb").trigger("click");
    // }
  });

  $(".footer-link h3").click(function () {
    $(this).toggleClass("active", 500);
    $(this).next(".show-m").toggle(500);
  });

  $(".h-blog-slide").slick({
    dots: true,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 2,
    centerMode: true,
    prevArrow: $(".prevb"),
    nextArrow: $(".nextb"),
    centerPadding: "300px",
    responsive: [
      {
        breakpoint: 1602,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerMode: true,
          centerPadding: "215px",
        },
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerMode: true,
          centerPadding: "150px",
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          centerPadding: "50px",
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          infinite: false,
          arrows: false,
          centerPadding: "10px",
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(document).ready(function () {
    $(".h-blog-slides").slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 2,
      centerMode: true,
      prevArrow: $(".prevb"),
      nextArrow: $(".nextb"),
      centerPadding: "300px",
      responsive: [
        {
          breakpoint: 1602,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
            centerMode: true,
            centerPadding: "215px",
          },
        },
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: true,
            centerPadding: "150px",
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "50px",
          },
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            infinite: false,
            arrows: false,
            centerPadding: "36px",
            slidesToScroll: 1,
          },
        },
      ],
    });

    $(".categories_slide").slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      // prevArrow: $('.prev'),
      // nextArrow: $('.next'),
      prevArrow:
        "<button type='button' class='prev '><img src='https://cdn.shopify.com/s/files/1/2149/6413/t/58/assets/prev-arrow.svg?v=76522808690051958051672654040'></button>",
      nextArrow:
        "<button type='button' class='next'><img src='https://cdn.shopify.com/s/files/1/2149/6413/t/58/assets/next-arrow.svg?v=84518816879809468751672654040'></button>",
      centerPadding: "300px",
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1605,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "221px",
          },
        },
        {
          breakpoint: 1578,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "140px",
          },
        },
        {
          breakpoint: 1410,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "80px",
          },
        },
        {
          breakpoint: 1240,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: "40px",
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            arrows: false,
            centerPadding: "40px",
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            arrows: false,
            centerPadding: "120px",
            slidesToScroll: 1,
          },
        },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     centerMode: true,
        //     centerPadding: '30px',
        //     slidesToScroll: 1
        //   }
        // },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "120px",
            slidesToScroll: 1,
          },
        },
      ],
    });
  });

  $(".single-blog .img a").each(function () {
    $(this).find("img:first").hide();
    var _Bg = "url(" + $(this).find("img:first").attr("src") + ")";
    $(this).css("background-image", _Bg);
    $(this).find("img:first").hide();
  });

  $(".single-case-studies .img a").each(function () {
    $(this).find("img:first").hide();
    var _Bg = "url(" + $(this).find("img:first").attr("src") + ")";
    $(this).css("background-image", _Bg);
    $(this).find("img:first").hide();
  });
  $(".single-media .img").each(function () {
    $(this).find("img:first").hide();
    var _Bg = "url(" + $(this).find("img:first").attr("src") + ")";
    $(this).css("background-image", _Bg);
    $(this).find("img:first").hide();
  });

  $(".article-template-banner").each(function () {
    $(this).find("img:first").hide();
    var _Bg = "url(" + $(this).find("img:first").attr("src") + ")";
    $(this).css("background-image", _Bg);
    $(this).find("img:first").hide();
  });

  jQuery(".video")
    .parent()
    .click(function () {
      if ($(this).children(".video").get(0).paused) {
        $(this).children(".video").get(0).play();
        $(this).children(".playpause").fadeOut();
      } else {
        $(this).children(".video").get(0).pause();
        $(this).children(".playpause").fadeIn();
      }
    });

  $(document).on('click', '.qty-flex .qty', function (t) {
    var $button = $(this);
    var oldValue = $button.parent().find("input").val();

    if ($button.hasClass("qty-plus")) {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      // Don't allow decrementing below zero
      if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 0;
      }
    }

    $button.parent().parent().find("input").val(newVal);
  });

  const createSVG = (width, height, radius) => {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");

    const rectangle = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "rect"
    );

    svg.setAttributeNS(
      "http://www.w3.org/2000/svg",
      "viewBox",
      `0 0 ${width} ${height}`
    );

    rectangle.setAttribute("x", "0");
    rectangle.setAttribute("y", "0");
    rectangle.setAttribute("width", "100%");
    rectangle.setAttribute("height", "100%");
    rectangle.setAttribute("rx", `${radius}`);
    rectangle.setAttribute("ry", `${radius}`);
    rectangle.setAttribute("pathLength", "10");

    svg.appendChild(rectangle);

    return svg;
  };

  document.querySelectorAll(".btn-primary").forEach((button) => {
    const style = getComputedStyle(button);

    const lines = document.createElement("div");

    lines.classList.add("lines");

    const groupTop = document.createElement("div");
    const groupBottom = document.createElement("div");

    const svg = createSVG(
      button.offsetWidth,
      button.offsetHeight,
      parseInt(style.borderRadius, 10)
    );

    groupTop.appendChild(svg);
    groupTop.appendChild(svg.cloneNode(true));
    groupTop.appendChild(svg.cloneNode(true));
    groupTop.appendChild(svg.cloneNode(true));

    groupBottom.appendChild(svg.cloneNode(true));
    groupBottom.appendChild(svg.cloneNode(true));
    groupBottom.appendChild(svg.cloneNode(true));
    groupBottom.appendChild(svg.cloneNode(true));

    lines.appendChild(groupTop);
    lines.appendChild(groupBottom);

    button.appendChild(lines);

    button.addEventListener("pointerenter", () => {
      button.classList.add("start");
    });

    svg.addEventListener("animationend", () => {
      button.classList.remove("start");
    });
  });

  $(".product-slide").slick({
    dots: true,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      "<button type='button' class='prev'><img src='https://cdn.shopify.com/s/files/1/2149/6413/t/58/assets/prev-arrow.svg?v=76522808690051958051672654040'></button>",
    nextArrow:
      "<button type='button' class='next'><img src='https://cdn.shopify.com/s/files/1/2149/6413/t/58/assets/next-arrow.svg?v=84518816879809468751672654040'></button>",
  });

  $(document).ready(function () {
    $('ul.accordion').accordion();
  });
  $(window).load(function () {
    console.log('Specs items:', $(".pro-specifications .accordion li a").length);
    console.log('FAQ items:', $(".collection-faq-wrap .accordion li a").length);
    $(".collection-faq-wrap .accordion li a").eq(0).trigger("click");
    $(".pro-specifications .accordion li a").eq(0).trigger("click");
    $(".sample-aaplication-faq .accordion li a").eq(0).trigger("click");
    // $(".pro-faq-qua-wrap .collection-faq-row .accordion li a")
    //   .eq(0)
    //   .trigger("click");
    $(".pro-faq-wrap .collection-faq-row .accordion li a")
      .eq(0)
      .trigger("click");
  });

  $(document).on("scroll", function () {
    var featHeight = $(".ab-product-wrap").height();
    setTimeout(function () {
      if ($(document).scrollTop() > featHeight) {
        $(".sticky_cart").addClass("fixed");
      } else {
        $(".sticky_cart").removeClass("fixed");
      }
    }, 300);
  });

  $(document).ready(function () {
    $(".product2-des .select-dropdown__button").click(function () {
      $(this).parents(".swatch").toggleClass("active");
      $(this).parents("body").toggleClass("activew");
      $(this).parents(".swatch").siblings().removeClass("active");
    });

    $(".blal").click(function () {
      var valu = $(this).attr("data-value");
      $(this)
        .parent(".select-dropdown__list-item")
        .parent(".select-dropdown__list")
        .parent(".select-dropdown")
        .find(".spentxt")
        .html(valu);
      $(this)
        .parent(".select-dropdown__list-item")
        .parent(".select-dropdown__list")
        .removeClass("active");
      $(this).parents().find(".swatch").removeClass("active");
    });
  });

  //  $(".blal ").click(function() {
  //   $(this).closest('.select-dropdown').find('.select-dropdown__button span').text($(this).text());
  // });
  $(document).ready(function () {
    $(document).keydown(function (e) {
      if (e.keyCode == 27) {
        $(".swatch ").removeClass("active");
        $("body").removeClass("activew");
        $(".Collapsible .collapse-headers").removeClass("active");
        $(".Collapsible").removeClass("active");
      }
    });
  });
  $(document).mouseup(function (e) {
    var container = $(".swatch");
    var containerfilter = $(".Collapsible");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $(".swatch").removeClass("active");
      $("body").removeClass("activew");
    }
    if (
      !containerfilter.is(e.target) &&
      containerfilter.has(e.target).length === 0
    ) {
      $(".Collapsible .collapse-headers").removeClass("active");
      $(".Collapsible").removeClass("active");
    }
  });

  $(document).ready(function () {
    const startTime = performance.now();

    // Find all text nodes in the body
    const walk = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    const nodesToModify = [];
    let node;

    // Collect all text nodes containing ®
    while (node = walk.nextNode()) {
      if (node.nodeValue.includes('®')) {
        nodesToModify.push(node);
      }
    }

    // Replace ® with <sup>®</sup> in collected nodes
    nodesToModify.forEach(textNode => {
      const fragment = document.createDocumentFragment();
      const parts = textNode.nodeValue.split(/(®)/g);

      parts.forEach(part => {
        if (part === '®') {
          const sup = document.createElement('sup');
          sup.textContent = '®';
          fragment.appendChild(sup);
        } else {
          fragment.appendChild(document.createTextNode(part));
        }
      });

      textNode.parentNode.replaceChild(fragment, textNode);
    });

    const endTime = performance.now();
    console.log(`FOUND AND WRAPPED ${nodesToModify.length} REGISTERED TRADEMARKS IN ${(endTime - startTime).toFixed(2)}ms`);
  });


  $(".toggle").click(function () {
    $(".product2-right").toggleClass("active");
  });

  //     $(document).on('click', '.collapse-headers', function(){
  //   $(this).toggleClass('active');
  //   $(this).next('.collapse-items').toggleClass('show');
  // });

  $("body").on(
    "click",
    ".collection-filters-form .Collapsible .collapse-headers", ".collapse-headers img",
    function () {
      $(this).toggleClass("active");
      $(this).parent(".Collapsible").toggleClass("active");
      // $(this).parents('body').toggleClass("activew");
      $(this).parent(".Collapsible").siblings().removeClass("active");
    }
  );
  //   $('.Collapsible .collapse-headers').click(function(event){
  //    event.stopPropagation();
  // });
  //       $('body').click(function() {
  //    $('.Collapsible .collapse-headers').removeClass("active");
  //         $('.Collapsible').removeClass("active");
  // });

  //   $('input#Search-In-Modal-1').keyup(function() {
  //      if($(this).val().length > 1) {
  //         $('body').addClass("width-100");

  //     } else {
  //        $('body').removeClass("width-100");
  //     }
  // });
  $(".search-icon").click(function () {
    $(".desk-search_wrap").addClass("active"),
      setTimeout(function () {
        
        $("#goal-input").focus();
        $(".Search__Input").focus();
      }, 500);
       
    $('body').addClass('no-scroll');
    }),
      
    $('.search-i').click(function(){
    $('.desk-search_wrap').removeClass('active');
    $('body').removeClass('no-scroll');
      $('.header__search details').removeAttr("open");
      $('input[type="search"]').val('');
      $('.Search__Results').attr('aria-hidden', 'true'); // hide results
    })

 //$('.modal__close-button').click(function(){
   // $('body').removeClass("width-100");
    //$('input.search__input[type="search"]').val('');
    //$(".search-modal__form").removeAttr("open");
  //});

  $(window).scroll(function () {
    var sticky = $(".header_wrap"),
      scroll = $(window).scrollTop();

    if (scroll >= 50) sticky.addClass("fixed");
    else sticky.removeClass("fixed");
  });

  $(".mobile-show-f .link").click(function () {
    $(".faq-list").toggleClass("more", 500);
    if ($(".mobile-show-f .link").text() == "MORE FILTERS") {
      $(this).text("CLOSE FILTERS");
    } else {
      $(this).text("MORE FILTERS");
    }
  });

  $("a.link.read-bio").click(function () {
    $(this).parents(".meet-team-row").addClass("show-bio");
  });
  $(".link.hide-bio ").click(function () {
    $(this).parents(".meet-team-row").removeClass("show-bio");
  });

  $(".add_to_cart_buttona").click(function () {
    $(this).addClass("active");
    setTimeout(function () {
      $(".add_to_cart_buttona").removeClass("active");
    }, 250);
  });
  $(".btn").click(function () {
    $(this).addClass("active");
    setTimeout(function () {
      $(".btn").removeClass("active");
    }, 400);
  });

  // $(document).ready(function(){
  //       $(".accordion-titel").click(function(){
  //       $(this).parent(".accordion-item").find(".accordion-contant").slideToggle();
  //       $(this).parent(".accordion-item").prevAll(".accordion-item").find(".accordion-contant").slideUp();
  //       $(this).parent(".accordion-item").nextAll(".accordion-item").find(".accordion-contant").slideUp();
  //       });
  //   });

  //   $(document).ready(function() {
  // 	$('.accordion-item').on('click', '.accordion-titel', function() {
  // 		$('.accordion-contant').slideUp().removeClass('flipInX');
  // 		$('.accordion-titel').removeClass('fa-minus');
  // 		if($(this).next().is(':hidden')) {
  // 			$(this).next().slideDown().addClass('flipInX');
  // 			$(this).find('.accordion-titel').addClass('fa-minus');
  // 		} else {
  // 			$(this).next().slideUp();
  // 			$(this).find('.accordion-titel').addClass('fa-plus');
  // 		}
  // 	});
  // });

  $(".accordion-item").on("click", ".accordion-titel", function () {
    $(".accordion-contant").slideUp();

    if ($(this).hasClass("active")) {
      $(this).next().slideUp();
      $(this).removeClass("active");
    } else {
      $(this).next().slideDown();
      $(".accordion-titel").removeClass("active");
      $(this).addClass("active");
    }
  });

  // $(document).ready(function() {
  //   $.fancybox.open({
  //   type: "inline",
  //   touch: false
  // });
  //});

  $(".open-pop").magnificPopup({
    type: "inline",
    fixedContentPos: true,
    midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
  });
  $(document).ready(function () {
    $(".f-button").click(function () {
      $.magnificPopup.close();
    });
  });
  //   jQuery('#sign-up').fancybox({
  //     mobile: {
  //            clickSlide: false,
  //             touch: false
  //         },
  // });
  //  $(':button').click(function() {
  //     parent.$.fancybox.close();
  // })
})(jQuery);

$(document).ready(function () {
  // Attach a click event handler to the select element within the specific .item
  $(".item .select-wrp select").on("change", function () {
    // Get the selected value from the select element
    var selectedValue = $(this).val();

    // Find the parent .item and then find retail_prices within that specific item
    var retailPrices = $(this).closest(".item").find(".retail_prices");

    // Hide all h5 elements under retail_prices within the specific item
    retailPrices.find("div").hide();

    // Show the specific h5 element based on the selected value within the specific item
    retailPrices.find('div[value="' + selectedValue + '"]').show();
  });
});

var KlaviyoSubscribe = KlaviyoSubscribe || {};
(function () {
  if (!KlaviyoSubscribe._loaded) {
    KlaviyoSubscribe._loaded = !0;
    var m = {
      "modal.html":
        '<div class="klaviyo_modal" style="display:none;"><div class="klaviyo_inner"><a href="#" class="klaviyo_close_modal klaviyo_header_close">&times;</a><form action="" method="POST" novalidate="novalidate" class="klaviyo_subscription_form"><input type="hidden" name="g" value="" /><p class="klaviyo_header"></p><p class="klaviyo_subheader"></p><div class="klaviyo_fieldset"></div><div class="klaviyo_fine_print"></div><div class="klaviyo_form_actions"><button type="submit" class="klaviyo_submit_button"><span></span></button></div><div class="klaviyo_below_submit"></div><div class="error_message" style="display:none;"></div></form><div class="success_message" style="display:none;"></div></div></div>',
      "flyout.html":
        '<div class="klaviyo_flyout" style="display:none;"><div class="klaviyo_inner"><div class="klaviyo_topbar" /><a href="#" class="klaviyo_close_flyout klaviyo_header_close">&times;</a><p class="klaviyo_header"></p><p class="klaviyo_subheader"></p><div class="klaviyo_flyout_action"><a href="#"><span /> &raquo;</a></div></div></div>',
      "flyout_form.html":
        '<div class="klaviyo_flyout" style="display:none;"><div class="klaviyo_inner"><div class="klaviyo_topbar" /><a href="#" class="klaviyo_close_flyout klaviyo_header_close">&times;</a><form action="" method="POST" novalidate="novalidate" class="klaviyo_subscription_form"><input type="hidden" name="g" value="" /><p class="klaviyo_header"></p><p class="klaviyo_subheader"></p><div class="klaviyo_inline_fieldset"><input type="email" name="email" placeholder="Your email address" /><button type="submit" class="klaviyo_submit_button"><span></span></button></div><div class="error_message" style="display:none;"></div></form><div class="success_message" style="display:none;"></div></div></div>',
    },
      n =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      p = {
        $email: "Email Address",
        $first_name: "First Name",
        $last_name: "Last Name",
      },
      h = "klaClosedPopup";
    KlaviyoSubscribe._debug = -1 < document.location.hash.indexOf("#test");
    KlaviyoSubscribe.has_called_bootstrap = !1;
    KlaviyoSubscribe.is_requirements_loaded = !1;
    KlaviyoSubscribe.bootstrap_queue = [];
    KlaviyoSubscribe.bootstrap_attempts = 0;
    KlaviyoSubscribe.instances = {};
    KlaviyoSubscribe.isDebugMode = function () {
      return KlaviyoSubscribe._debug;
    };
    KlaviyoSubscribe.bootstrap = function (a) {
      KlaviyoSubscribe.has_called_bootstrap ||
        ((KlaviyoSubscribe.has_called_bootstrap = !0),
          KlaviyoSubscribe.loadCss(
            "//a.klaviyo.com/media/css/public/klaviyo_subscribe.css"
          ),
          KlaviyoSubscribe.fetchRequirements(a));
    };
    KlaviyoSubscribe.setHasClosedModalCookieName = function (a) {
      h = a || h;
    };
    KlaviyoSubscribe.loadScript = function (a, b, c) {
      var d = document.getElementsByTagName("head")[0],
        e = document.createElement("script");
      e.type = "text/javascript";
      e.src = a;
      d.appendChild(e);
      KlaviyoSubscribe.log("Loaded JS", a);
      KlaviyoSubscribe.whenTrue(b, c);
    };
    KlaviyoSubscribe.loadCss = function (a) {
      var b = document.getElementsByTagName("head")[0],
        c = document.createElement("link");
      c.rel = "stylesheet";
      c.type = "text/css";
      c.href = a;
      b.appendChild(c);
      KlaviyoSubscribe.log("Loaded CSS", a);
    };
    KlaviyoSubscribe.injectCSS = function (a) {
      var b = document.getElementsByTagName("head")[0],
        c = document.createElement("style");
      c.type = "text/css";
      c.styleSheet
        ? (c.styleSheet.cssText = a)
        : c.appendChild(document.createTextNode(a));
      b.appendChild(c);
    };
    KlaviyoSubscribe.whenTrue = function (a, b) {
      var c = 0,
        d = function () {
          a() ? b() : (c++, 100 > c && setTimeout(d, 200));
        };
      d();
    };
    KlaviyoSubscribe.loadJQuery = function (a) {
      KlaviyoSubscribe.loadScript(
        "//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js",
        function () {
          return !!window.jQuery;
        },
        a
      );
    };
    KlaviyoSubscribe.loadJQueryForm = function (a) {
      KlaviyoSubscribe.loadScript(
        "//cdnjs.cloudflare.com/ajax/libs/jquery.form/3.32/jquery.form.min.js",
        function () {
          return (
            !!window.jQuery && jQuery.fn.ajaxForm && jQuery.fn.formSerialize
          );
        },
        a
      );
    };
    KlaviyoSubscribe.fetchRequirements = function (a) {
      document.getElementsByTagName("head");
      a = a || {};
      if (window.jQuery)
        jQuery.fn.ajaxForm
          ? KlaviyoSubscribe.processQueue()
          : KlaviyoSubscribe.loadJQueryForm(KlaviyoSubscribe.processQueue);
      else {
        var b = function () {
          KlaviyoSubscribe.log("jQuery loaded.");
          KlaviyoSubscribe.loadJQueryForm(KlaviyoSubscribe.processQueue);
        };
        !0 === a.assume_jquery
          ? KlaviyoSubscribe.whenTrue(function () {
            return !!window.jQuery;
          }, b)
          : KlaviyoSubscribe.loadJQuery(b);
      }
    };
    KlaviyoSubscribe.processQueue = function () {
      var a,
        b = function () {
          for (
            KlaviyoSubscribe.log("Processing queue.");
            (a = KlaviyoSubscribe.bootstrap_queue.shift());

          )
            a();
          KlaviyoSubscribe.bootstrap_queue.push = function (a) {
            a();
          };
        };
      KlaviyoSubscribe.log("Waiting for DOM to process queue.");
      jQuery(b);
      setTimeout(b, 5e3);
    };
    KlaviyoSubscribe.executeWhenRequirementsLoaded = function (a) {
      KlaviyoSubscribe.bootstrap_queue.push(a);
    };
    KlaviyoSubscribe.watchField = function (a, b, c) {
      c = c || {};
      c.type = c.type || "text";
      if ("email" === b || "$email" === b) c.type = "email";
      KlaviyoSubscribe.bootstrap();
      KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
        KlaviyoSubscribe.log("Watching field", a, jQuery(a).length);
        var d = function (a) {
          a = jQuery.trim($(a.target).val());
          KlaviyoSubscribe.log("Watch field value", a);
          if ("email" !== c.type || n.test(a)) {
            if (window._learnq && _learnq.push) {
              var d = {};
              d[b] = a;
              _learnq.push(["identify", d]);
            }
            c.callback && c.callback(b, a);
          }
        };
        if (c.delegate) jQuery(c.delegate).on("change blur", a, d);
        else jQuery(a).on("change blur", d);
      });
    };
    KlaviyoSubscribe.watchFormSubmission = function (a, b) {
      b = b || {};
      b.properties = b.properties || {};
      b.list &&
        (KlaviyoSubscribe.bootstrap(),
          KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
            if (b.properties) {
              var c = [];
              jQuery.each(b.properties, function (a, b) {
                c.push(a);
              });
              c.length && (b.properties.$fields = c.join(","));
            }
            KlaviyoSubscribe.log("Watching form", a, jQuery(a).length);
            var d = function (a) {
              var c = $(a.target);
              if (window._learnq && _learnq.identify) {
                var d = _learnq.identify();
                if (d && (d = d.$email || d.email)) {
                  if (b.if) {
                    var e = jQuery(b.if);
                    if (
                      !e.length ||
                      (e.is(":checkbox") ? !e.is(":checked") : !e.val())
                    ) {
                      KlaviyoSubscribe.log("Subscribe if fails", e);
                      return;
                    }
                  }
                  d = jQuery.extend({ g: b.list, email: d }, b.properties);
                  KlaviyoSubscribe.log("Subscribing", d);
                  $.post(
                    "//manage.kmail-lists.com/ajax/subscriptions/subscribe",
                    d
                  );
                  KlaviyoSubscribe._logMetric("submitModal", b.list);
                  b.wait_seconds &&
                    (a.preventDefault(),
                      setTimeout(function () {
                        KlaviyoSubscribe.log("Submitting form", c);
                        c.get(0).submit();
                      }, 1e3 * b.wait_seconds));
                }
              }
            };
            if (b.delegate) jQuery(b.delegate).on("submit", a, d);
            else jQuery(a).on("submit", d);
          }));
    };
    KlaviyoSubscribe.attachToForms = function (a, b) {
      b = b || {};
      var c = b.extra_properties || {};
      c.$source = c.$source || "$embed";
      KlaviyoSubscribe.bootstrap();
      KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
        KlaviyoSubscribe.log("Attaching to forms", a, jQuery(a).length);
        jQuery(a).each(function () {
          var a = jQuery(this),
            e = a.data("ajax-submit");
          e || (e = "//manage.kmail-lists.com/ajax/subscriptions/subscribe");
          a.ajaxForm({
            url: e,
            type: "POST",
            beforeSubmit: function (b, d, e) {
              try {
                if (!KlaviyoSubscribe.isFormValid(a)) return !1;
              } catch (k) {
                return (
                  KlaviyoSubscribe.log(k),
                  a.find(".error_message").show().html(k),
                  a.trigger("klaviyo.subscribe.error"),
                  !1
                );
              }
              KlaviyoSubscribe.log("$source", c.$source);
              KlaviyoSubscribe.normalizeFormFields(b, a, c, e);
              KlaviyoSubscribe._logMetric(
                "submitModal",
                b.find(function (a) {
                  return "g" === a.name;
                }).value
              );
              a.find(".klaviyo_submit_button").attr("disabled", !0);
            },
            success: function (c, d, e) {
              a.find(".success_message, .error_message").hide();
              a.find(".klaviyo_submit_button").attr("disabled", !1);
              c.success
                ? (KlaviyoSubscribe.setClosedModalCookie(),
                  (d = a.find(".success_message").show()),
                  d.length || (d = a.parent().find(".success_message").show()),
                  window._learnq &&
                  _learnq.push &&
                  (e = a.find('[name="email"]').val()) &&
                  (_learnq.push(["identify", { $email: e }]),
                    _learnq.push(["trackActivity"])),
                  b.success_url
                    ? (window.location = b.success_url)
                    : (!0 !== b.custom_success_message &&
                      d
                        .html(
                          b.success_message ||
                          '<div class="klaviyo_header">Thanks for subscribing!</div><div class="klaviyo_subheader">Check your email for a confirmation message.</div>'
                        )
                        .end(),
                      !0 === b.hide_form_on_success &&
                      (a
                        .find(
                          ".klaviyo_field_group input, .klaviyo_form_actions"
                        )
                        .hide(),
                        a.is(".klaviyo_horizontal_form") &&
                        a.find(".klaviyo_field_group").hide()),
                      b.success && b.success(a, c.data),
                      a.trigger("klaviyo.subscribe.success").resetForm()))
                : (KlaviyoSubscribe.log(c.errors),
                  a.find(".error_message").show().html(c.errors.join(" ")),
                  a.trigger("klaviyo.subscribe.error"));
            },
          });
          KlaviyoSubscribe.log("Attached to form", this);
        });
      });
    };
    KlaviyoSubscribe.attachModalSignUp = function (a) {
      a = a || {};
      a.pages = a.pages || [];
      a.excluded_pages = a.excluded_pages || [];
      a.delay_seconds = a.delay_seconds || 0.1;
      a.delay_num_pages = a.delay_num_pages || 0;
      a.content = a.content || {};
      a.extra_properties = a.extra_properties || {};
      a.extra_properties.$source = a.extra_properties.$source || "$modal";
      a.list &&
        (KlaviyoSubscribe.bootstrap(),
          KlaviyoSubscribe.setHasClosedModalCookieName(
            a.has_closed_modal_cookie_name
          ),
          KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
            var b = KlaviyoSubscribe._buildModalSignUp(a);
            b.find('[name="g"]').val(a.list);
            b.appendTo(jQuery("body"));
            KlaviyoSubscribe.attachToModalForm(b, {
              list: a.list,
              pages: a.pages,
              excluded_pages: a.excluded_pages,
              delay: a.delay_seconds,
              delay_num_pages: a.delay_num_pages,
              ignore_cookie: a.ignore_cookie,
              extra_properties: a.extra_properties,
              custom_success_message: !!a.content.success,
              success_url: a.success_url,
              success: function (b) {
                b.hide();
                a.success && a.success(b);
              },
            });
          }));
    };
    KlaviyoSubscribe._buildModalSignUp = function (a) {
      var b = a.content;
      b.fields = b.extra_fields || [];
      -1 === jQuery.inArray("$email", b.fields) && b.fields.unshift("$email");
      if (b.element) return jQuery(b.element);
      var c = jQuery(m["modal.html"])
        .attr("id", "k_id_modal")
        .find(".klaviyo_header")
        .html(b.header || "Interested in our Newsletter?")
        .end()
        .find(".klaviyo_subscription_form")
        .attr(
          "action",
          a.subscribe_url || "//manage.kmail-lists.com/subscriptions/subscribe"
        )
        .data(
          "ajax-submit",
          a.ajax_subscribe_url ||
          "//manage.kmail-lists.com/ajax/subscriptions/subscribe"
        )
        .end()
        .find(".klaviyo_submit_button span")
        .html(b.button || "Subscribe")
        .end();
      b.clazz && c.addClass(b.clazz);
      b.styles && KlaviyoSubscribe.injectCSS(b.styles);
      !1 !== b.subheader &&
        c
          .find(".klaviyo_subheader")
          .html(b.subheader || "Stay in the know with news and promotions.");
      b.below_submit
        ? c.find(".klaviyo_below_submit").html(b.below_submit)
        : c.find(".klaviyo_below_submit").hide();
      b.success && c.find(".success_message").html(b.success);
      !0 === a.ack &&
        c.append(
          jQuery(
            '<div class="klaviyo_ack"><a href="http://www.klaviyo.com/?utm_campaign=pbk">Powered by Klaviyo</a></div>'
          )
        );
      var d = c.find(".klaviyo_fieldset");
      jQuery.each(b.fields, function (a, b) {
        "string" === typeof b && (b = { name: b });
        b.type || (b.type = "$email" === b.name ? "email" : "text");
        b.label || (b.label = p[b.name] || b.name);
        a = "k_id_modal_" + b.name;
        d.append(
          jQuery('<div class="klaviyo_field_group" />')
            .append(jQuery("<label />").attr("for", a).html(b.label))
            .append(
              jQuery("<input />").attr({
                type: b.type,
                id: a,
                name: "$" === b.name[0] ? b.name.slice(1) : b.name,
              })
            )
        );
      });
      a = b.fine_print || "";
      b.email_frequency &&
        (a +=
          " Our newsletter is delivered to your inbox " +
          b.email_frequency +
          ".");
      c.find(".klaviyo_fine_print").html(a);
      return c;
    };
    KlaviyoSubscribe.attachToModalForm = function (a, b) {
      b = b || {};
      b.pages = b.pages || [];
      b.excluded_pages = b.excluded_pages || [];
      b.extra_properties = b.extra_properties || {};
      b.extra_properties.$source = b.extra_properties.$source || "$modal";
      void 0 === b.delay_seconds &&
        (b.delay_seconds = void 0 === b.delay ? 2 : b.delay);
      KlaviyoSubscribe.bootstrap();
      KlaviyoSubscribe.setHasClosedModalCookieName(
        b.has_closed_modal_cookie_name
      );
      KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
        var c = jQuery(a);
        KlaviyoSubscribe.attachToForms(
          jQuery(a).find(".klaviyo_subscription_form"),
          b
        );
        c.delegate(".klaviyo_close_modal", "click", function (a) {
          a.preventDefault();
          c.hide();
          KlaviyoSubscribe.setClosedModalCookie();
          KlaviyoSubscribe._logMetric("closeModal", b.list);
        });
        c.click(function (a) {
          a.currentTarget === a.target &&
            (c.hide(), KlaviyoSubscribe.setClosedModalCookie());
        });
        KlaviyoSubscribe._canShowElem(b) &&
          jQuery(function () {
            setTimeout(function () {
              KlaviyoSubscribe._logMetric("openModal", b.list);
              c.fadeIn(1e3);
              c.trigger("klaviyo.modal.show");
            }, 1e3 * b.delay_seconds);
          });
      });
    };
    KlaviyoSubscribe.attachFlyoutSignUp = function (a) {
      a = a || {};
      a.pages = a.pages || [];
      a.excluded_pages = a.excluded_pages || [];
      a.delay_scroll = void 0 === a.delay_scroll ? 50 : a.delay_scroll;
      a.delay_seconds = a.delay_seconds || 0.1;
      a.delay_num_pages = a.delay_num_pages || 0;
      a.position = a.position || "right";
      a.content = a.content || {};
      a.extra_properties = a.extra_properties || {};
      a.extra_properties.$source = a.extra_properties.$source || "$flyout";
      void 0 === a.modal_content && (a.modal_content = a.content);
      a.list &&
        (KlaviyoSubscribe.bootstrap(),
          KlaviyoSubscribe.setHasClosedModalCookieName(
            a.has_closed_modal_cookie_name
          ),
          KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
            var b = !1 === a.modal_content,
              c = KlaviyoSubscribe._buildFlyoutSignUp(
                jQuery.extend({ include_form: b }, a)
              );
            c.appendTo(jQuery("body"));
            if (b) {
              var d = a.success;
              a.success = function (a) {
                a.hide();
                KlaviyoSubscribe.setClosedModalCookie();
                d && d(a);
              };
              a.custom_success_message = !!a.content.success;
              c.find('[name="g"]').val(a.list);
              KlaviyoSubscribe.attachToForms(
                c.find(".klaviyo_subscription_form"),
                a
              );
            }
            KlaviyoSubscribe.attachToFlyout(c, {
              list: a.list,
              pages: a.pages,
              excluded_pages: a.excluded_pages,
              delay: a.delay_seconds,
              delay_scroll: a.delay_scroll,
              delay_num_pages: a.delay_num_pages,
              position: a.position,
              ignore_cookie: a.ignore_cookie,
              extra_properties: a.extra_properties,
              click: function (b) {
                b = KlaviyoSubscribe._buildModalSignUp({
                  content: a.modal_content,
                });
                b.find('[name="g"]').val(a.list);
                b.appendTo(jQuery("body"));
                KlaviyoSubscribe.attachToModalForm(b, {
                  list: a.list,
                  delay: 0.01,
                  extra_properties: a.extra_properties,
                  success_url: a.success_url,
                  success: function (b) {
                    b.hide();
                    a.success && a.success(b);
                  },
                });
              },
            });
          }));
    };
    KlaviyoSubscribe._buildFlyoutSignUp = function (a) {
      var b = a.content;
      if (b.element) return jQuery(b.element);
      var c = jQuery(m[a.include_form ? "flyout_form.html" : "flyout.html"])
        .attr("id", "k_id_flyout")
        .find(".klaviyo_header")
        .html(b.header || "Interested in our Newsletter?")
        .end()
        .find(".klaviyo_subscription_form")
        .attr(
          "action",
          a.subscribe_url || "//manage.kmail-lists.com/subscriptions/subscribe"
        )
        .data(
          "ajax-submit",
          a.ajax_subscribe_url ||
          "//manage.kmail-lists.com/ajax/subscriptions/subscribe"
        )
        .end()
        .find(".klaviyo_flyout_action a span, .klaviyo_submit_button span")
        .html(b.button || "Subscribe")
        .end();
      c.addClass("klaviyo_" + a.position);
      b.clazz && c.addClass(b.clazz);
      b.styles && KlaviyoSubscribe.injectCSS(b.styles);
      !1 !== b.subheader &&
        c
          .find(".klaviyo_subheader")
          .html(b.subheader || "Stay in the know with news and promotions.");
      b.success && c.find(".success_message").html(b.success);
      !0 === a.ack &&
        c
          .find(".klaviyo_inner")
          .append(
            jQuery(
              '<div class="klaviyo_ack"><a href="http://www.klaviyo.com/?utm_campaign=pbk">Powered by Klaviyo</a></div>'
            )
          );
      return c;
    };
    KlaviyoSubscribe.attachToFlyout = function (a, b) {
      b = b || {};
      b.pages = b.pages || [];
      b.excluded_pages = b.excluded_pages || [];
      b.position = b.position || "right";
      b.extra_properties = b.extra_properties || {};
      b.extra_properties.$source = b.extra_properties.$source || "$flyout";
      KlaviyoSubscribe.bootstrap();
      KlaviyoSubscribe.setHasClosedModalCookieName(
        b.has_closed_modal_cookie_name
      );
      KlaviyoSubscribe.executeWhenRequirementsLoaded(function () {
        var c = jQuery(a);
        c.delegate(".klaviyo_close_flyout", "click", function (a) {
          a.preventDefault();
          c.hide();
          KlaviyoSubscribe.setClosedModalCookie();
          KlaviyoSubscribe._logMetric("closeModal", b.list);
        });
        c.find(".klaviyo_flyout_action a").click(function (a) {
          a.preventDefault();
          c.hide();
          b.click && b.click();
        });
        KlaviyoSubscribe._canShowElem(b) &&
          jQuery(function () {
            var a = b.delay_scroll,
              e = function () {
                if (!c.data("opened")) {
                  var a = b.delay_seconds || b.delay;
                  void 0 === a && (a = 2);
                  setTimeout(function () {
                    if (!c.data("opened")) {
                      c.data("opened", !0);
                      c.trigger("klaviyo.flyout.show");
                      var a = c.find(".klaviyo_inner"),
                        d =
                          -1 <
                            jQuery.inArray(b.position, [
                              "left",
                              "right",
                              "bottom",
                              "top",
                            ])
                            ? b.position
                            : "right",
                        e = {},
                        g;
                      e[d] = 0;
                      c.css("visibility", "hidden").show();
                      KlaviyoSubscribe._logMetric("openModal", b.list);
                      "left" === d
                        ? (g = 1.2 * -a.width())
                        : "right" === d
                          ? (g = 1.2 * -a.width())
                          : "top" === d
                            ? (g = 1.2 * -a.height())
                            : "bottom" === d && (g = 1.2 * -a.height());
                      a.css(d, g);
                      c.css("visibility", "visible");
                      a.animate(e, 1e3 * (b.slide_seconds || 2));
                    }
                  }, 1e3 * a);
                }
              };
            if (!1 === a || 0 === a) e();
            else {
              var f = jQuery(document),
                q = jQuery(window),
                g = "bottom" === a ? 95 : a,
                k = function () {
                  var a = f.height() - q.height();
                  (0 > a ? 100 : (100 * f.scrollTop()) / a) > g &&
                    (e(), f.unbind("scroll", k));
                };
              f.scroll(k);
            }
          });
      });
    };
    KlaviyoSubscribe.isFormValid = function (a) {
      var b = a.find('[name="email"]').val();
      if (!b || !/@/.test(b))
        throw (
          (KlaviyoSubscribe.log("Invalid email address"),
            "Invalid email address")
        );
      a.find('input[required="true"], select[required="true"]').each(function (
        b,
        d
      ) {
        d = jQuery(d);
        if (d.is(":radio") || d.is(":checked")) {
          has_value = !!a.find('[name="' + d.attr("name") + '"]:checked')
            .length;
          if (!has_value)
            throw (
              (KlaviyoSubscribe.log("Required field missing", d.attr("name")),
                "Required field missing: " + d.attr("name"))
            );
          return has_value;
        }
        if (!d.val())
          throw (
            (KlaviyoSubscribe.log("Required field missing", d.attr("name")),
              "Required field missing: " + d.attr("name"))
          );
      });
      a.find(".select-date-widget").each(function (a, b) {
        b = jQuery(b);
        a = KlaviyoSubscribe._int(b.find('[name$="_day"]').val());
        var c = KlaviyoSubscribe._int(b.find('[name$="_month"]').val());
        b = KlaviyoSubscribe._int(b.find('[name$="_year"]').val());
        if (!(isNaN(a) || isNaN(c) || isNaN(b))) {
          switch (c) {
            case 1:
            case 3:
            case 5:
            case 7:
            case 8:
            case 10:
            case 12:
              if (1 <= a && 31 >= a) return;
            case 4:
            case 6:
            case 9:
            case 11:
              if (1 <= a && 30 >= a) return;
            case 2:
              if (1 <= a && a <= (b % 4 ? 28 : 29)) return;
          }
          KlaviyoSubscribe.log("Invalid date", b, c, a);
          throw "Invalid date";
        }
      });
      return !0;
    };
    KlaviyoSubscribe.normalizeFormFields = function (a, b, c, d) {
      a.push({
        name: "$timezone_offset",
        type: "text",
        value: this._getUtcOffset(),
      });
      var e = [],
        f;
      jQuery.each(c, function (b, c) {
        a.push({ name: b, type: "text", value: c });
        e.push(b);
      });
      e.length &&
        (jQuery.each(a, function (a, b) {
          if ("$fields" === b.name) return (f = b), !1;
        }),
          f
            ? (f.value += "," + e.join())
            : a.push({ name: "$fields", type: "text", value: e.join() }));
      b.find(".select-date-widget").each(function (b, c) {
        c = jQuery(c);
        var d = c.find('[name$="_day"]');
        b = c.find('[name$="_month"]');
        var e = c.find('[name$="_year"]');
        c = d.attr("name");
        var f = b.attr("name"),
          g = e.attr("name");
        d = KlaviyoSubscribe._int(d.val());
        var h = KlaviyoSubscribe._int(b.val());
        e = KlaviyoSubscribe._int(e.val());
        if (!(isNaN(d) || isNaN(h) || isNaN(e))) {
          for (b = 0; b < a.length;) {
            var l = a[b];
            !l || (l.name !== c && l.name !== f && l.name !== g)
              ? b++
              : a.splice(b, 1);
          }
          a.push({
            name: c.replace("_day", ""),
            required: !0,
            type: "text",
            value: KlaviyoSubscribe._formatDate(e, h, d),
          });
        }
      });
    };
    KlaviyoSubscribe.isCurrentLocationInPatterns = function (a) {
      for (var b = location.toString(), c = 0, d = a.length; c < d; c++)
        if (KlaviyoSubscribe.patternMatchesUrl(a[c], b)) return !0;
      return !1;
    };
    KlaviyoSubscribe.patternMatchesUrl = function (a, b) {
      b = b.toLowerCase();
      if (a === b) return !0;
      if (-1 === a.indexOf("?")) {
        var c = b.indexOf("?");
        -1 !== c && (b = b.substring(0, c));
      }
      if (-1 === a.indexOf("*"))
        return (
          (a = a.replace(/\/$/, "")),
          "" === a && (a = "/"),
          (b = b.replace(/\/$/, "")),
          a === b
            ? !0
            : 0 === a.indexOf("/")
              ? ((b = KlaviyoSubscribe.parseDomain(b)),
                "" === a ? "/" === b : b === a)
              : !1
        );
      if (a === b) return !0;
      if (!a.length) return !1;
      c = a.replace(/[.+?|()\[\]{}\\]/g, "\\$&").replace(/\*/g, "(.*?)");
      c = /\/$/.test(c) ? "^" + c + "$" : "^" + c + "/?$";
      c = new RegExp(c, "i");
      return c.test(b)
        ? !0
        : a.indexOf("/")
          ? !1
          : c.test(KlaviyoSubscribe.parseDomain(b));
    };
    KlaviyoSubscribe.parseDomain = function (a) {
      return "/" + a.split("//")[1].split("/").splice(1).join("/");
    };
    KlaviyoSubscribe.incrPageViews = function () {
      var a = parseInt(KlaviyoSubscribe._getCookie("klaPages"), 10);
      isNaN(a) && (a = 0);
      a += 1;
      KlaviyoSubscribe._setCookie("klaPages", a, 31536e6);
      return a;
    };
    KlaviyoSubscribe.setClosedModalCookie = function () {
      KlaviyoSubscribe._setCookie(h, "1", 31536e6);
    };
    KlaviyoSubscribe.resetClosedModalCookie = function () {
      KlaviyoSubscribe._deleteCookie(h);
    };
    KlaviyoSubscribe.hasClosedModal = function () {
      return (
        !!KlaviyoSubscribe._getCookie(h) && !KlaviyoSubscribe.isDebugMode()
      );
    };
    KlaviyoSubscribe._setCookie = function (a, b, c) {
      c = new Date(new Date().getTime() + c);
      document.cookie = a + "=" + b + ";expires=" + c.toGMTString() + ";path=/";
    };
    KlaviyoSubscribe._getCookie = function (a) {
      return (a = new RegExp("(^|;)[ ]*" + a + "=([^;]*)").exec(
        document.cookie
      ))
        ? a[2]
        : "";
    };
    KlaviyoSubscribe._deleteCookie = function (a) {
      KlaviyoSubscribe._getCookie(a) && KlaviyoSubscribe._setCookie(a, "", -1);
    };
    KlaviyoSubscribe._getUtcOffset = function () {
      return new Date().getTimezoneOffset() / -60;
    };
    KlaviyoSubscribe._canShowElem = function (a) {
      return (a.delay_num_pages &&
        a.delay_num_pages > KlaviyoSubscribe.incrPageViews()) ||
        (a.pages.length &&
          !KlaviyoSubscribe.isCurrentLocationInPatterns(a.pages)) ||
        (a.excluded_pages.length &&
          KlaviyoSubscribe.isCurrentLocationInPatterns(a.excluded_pages))
        ? !1
        : a.ignore_cookie || !KlaviyoSubscribe.hasClosedModal();
    };
    KlaviyoSubscribe._int = function (a) {
      return parseInt(a, 10);
    };
    KlaviyoSubscribe._formatDate = function (a, b, c) {
      1 === c.toString().length && (c = "0" + c);
      1 === b.toString().length && (b = "0" + b);
      return a + "-" + b + "-" + c;
    };
    KlaviyoSubscribe.log = function () {
      window.console && console.log && console.log(arguments);
    };
    KlaviyoSubscribe._logMetric = function (a, b) { };
    Array.prototype.find ||
      Object.defineProperty(Array.prototype, "find", {
        value: function (a, b) {
          if (null == this)
            throw new TypeError('"this" is null or not defined');
          var c = Object(this),
            d = c.length >>> 0;
          if ("function" !== typeof a)
            throw new TypeError("predicate must be a function");
          for (var e = 0; e < d;) {
            var f = c[e];
            if (a.call(b, f, e, c)) return f;
            e++;
          }
        },
      });
  }
})();
KlaviyoSubscribe.attachToForms("#email_signup", {
  hide_form_on_success: true,
});
KlaviyoSubscribe.attachToForms("#email_signupp", {
  hide_form_on_success: true,
});



document.addEventListener('DOMContentLoaded', function () {
  console.log("STICKY CART LISTENER ACTIVE");
  const announcementBar = document.querySelector('.announcement-bar');
  const stickyCart = document.querySelector('.sticky_cart');

  if (announcementBar && stickyCart) {
    stickyCart.classList.add('has-announcement');
  }
});



document.addEventListener('click', function (e) {
  if (e.target.matches('[data-action="select-value"]')) {
    e.preventDefault();

    // Remove is-selected class from any previously selected items
    document.querySelectorAll('[data-action="select-value"]').forEach(el => {
      el.classList.remove('is-selected');
    });

    // Add is-selected class to clicked element
    e.target.classList.add('is-selected');

    const sortValue = e.target.getAttribute('data-value');
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('sort_by', sortValue);

    // Update URL without reload
    window.history.pushState({}, '', currentUrl.toString());

    // Show loading state
    const productGrid = document.querySelector('.ProductList');
    if (productGrid) {
      productGrid.style.opacity = '0.5';
    }

    // Fetch new content
    fetch(currentUrl.toString())
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Get the new product grid
        const newProductGrid = doc.querySelector('.ProductList');

        if (newProductGrid && productGrid) {
          productGrid.innerHTML = newProductGrid.innerHTML;
          productGrid.style.opacity = '1';
        }
      })
      .catch(error => {
        console.error('Error:', error);
        // Fallback to page reload if fetch fails
        window.location.href = currentUrl.toString();
      });
  }
});



document.addEventListener('DOMContentLoaded', function () {
  const filterQuickBtn = document.querySelector('.filter-quick a');
  const collapsibleElements = document.querySelectorAll('.Collapsible.Collapsible--padded.Collapsible--autoExpand');
  let isActive = false;

  function isMobile() {
    return window.innerWidth < 615; // Standard mobile breakpoint
  }

  function setInitialState() {
    if (isMobile()) {
      // Apply mobile styles
      collapsibleElements.forEach(element => {
        element.style.display = 'none';
        element.style.height = '0px';
        element.style.opacity = '0';
        element.style.overflow = 'hidden';
        element.style.visibility = 'hidden';
      });
    } else {
      // Reset styles for desktop
      collapsibleElements.forEach(element => {
        element.style.display = '';
        element.style.height = '';
        element.style.opacity = '';
        element.style.overflow = '';
        element.style.visibility = '';
      });
    }
  }

  // Set initial state
  setInitialState();

  // Handle resize events
  window.addEventListener('resize', setInitialState);

  if (filterQuickBtn) {
    filterQuickBtn.addEventListener('click', function (e) {
      if (!isMobile()) return; // Exit if not mobile

      e.preventDefault();
      e.stopPropagation();
      isActive = !isActive;

      // Toggle button styling
      filterQuickBtn.classList.toggle('active');

      collapsibleElements.forEach(element => {
        if (isActive) {
          element.style.display = 'block';
          element.style.visibility = 'visible';
          element.style.transition = 'none';
          element.style.height = '0px';
          element.offsetHeight;

          element.style.transition = 'height 0.3s ease-out, opacity 0.3s ease-out';
          element.style.height = `${element.scrollHeight}px`;
          element.style.opacity = '1';

          element.addEventListener('transitionend', function handler() {
            if (isActive) {
              element.style.height = 'auto';
              element.style.overflow = 'visible';
            }
            element.removeEventListener('transitionend', handler);
          }, { once: true });
        } else {
          element.style.overflow = 'hidden';
          element.style.height = `${element.scrollHeight}px`;
          element.offsetHeight;

          element.style.transition = 'height 0.3s ease-out, opacity 0.3s ease-out';
          element.style.height = '0px';
          element.style.opacity = '0';

          element.addEventListener('transitionend', function handler() {
            if (!isActive) {
              element.style.display = 'none';
              element.style.visibility = 'hidden';
            }
            element.removeEventListener('transitionend', handler);
          }, { once: true });
        }
      });
    });
  }
});